import React from 'react';
import { ShoppingCart } from 'lucide-react';
import { products } from '../data/products';
interface FeaturedProductsProps {
  onNavigate?: (page: 'home' | 'archive' | 'detail', productId?: number) => void;
}
export function FeaturedProducts({
  onNavigate
}: FeaturedProductsProps) {
  // Display first 8 products
  const displayProducts = products.slice(0, 8);
  return <section className="w-full bg-background py-20" data-id="element-14">
      <div className="max-w-[1400px] mx-auto px-4 lg:px-8" data-id="element-15">
        <div className="flex justify-between items-end mb-12 border-b border-chrome/30 pb-4" data-id="element-16">
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-charcoal uppercase italic tracking-tight" data-id="element-17">
            Featured <span className="text-primary" data-id="element-18">Products</span>
          </h2>
          <button onClick={() => onNavigate && onNavigate('archive')} className="hidden sm:block text-charcoal font-heading font-bold text-lg uppercase italic tracking-wider hover:text-primary transition-colors" data-id="element-19">
            View All Products &rarr;
          </button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-20">
          {displayProducts.map(product => <div key={product.id} className="group bg-white border border-gray-100 hover:border-primary/50 transition-all duration-300" data-id="element-21">
              <div className="relative h-[250px] bg-gray-50 overflow-hidden p-4 cursor-pointer" onClick={() => onNavigate && onNavigate('detail', product.id)} data-id="element-22">
                <img src={product.image} alt={product.name} className="w-full h-full object-contain object-center group-hover:scale-105 transition-transform duration-500 mix-blend-multiply" data-id="element-23" />
                <div className="absolute top-0 right-0 bg-primary text-white text-xs font-bold px-2 py-1 italic uppercase skew-x-[-10deg]" data-id="element-24">
                  New
                </div>
                <button className="absolute bottom-0 left-0 w-full bg-charcoal text-white py-3 font-heading font-bold uppercase italic tracking-wider translate-y-full group-hover:translate-y-0 transition-transform duration-300 flex items-center justify-center gap-2" data-id="element-25">
                  <ShoppingCart className="w-4 h-4" data-id="element-26" /> View Details
                </button>
              </div>
              <div className="p-6" data-id="element-27">
                <h3 className="text-xl font-heading font-bold text-charcoal uppercase italic leading-none mb-2 line-clamp-2 h-[2.5rem] cursor-pointer hover:text-primary transition-colors" onClick={() => onNavigate && onNavigate('detail', product.id)} data-id="element-28">
                  {product.name}
                </h3>
                <p className="text-2xl font-heading font-bold text-primary italic" data-id="element-29">
                  {product.price}
                </p>
              </div>
            </div>)}
        </div>

        <div className="mt-12 text-center sm:hidden" data-id="element-30">
          <button onClick={() => onNavigate && onNavigate('archive')} className="inline-block px-8 py-3 bg-charcoal text-white font-heading font-bold uppercase italic tracking-wider hover:bg-primary transition-colors skew-x-[-10deg]" data-id="element-31">
            <span className="block skew-x-[10deg]" data-id="element-32">View All Products</span>
          </button>
        </div>
      </div>
    </section>;
}